import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { FormattedMessage } from 'react-intl'
import { FormattedDate } from 'components/intl'
import { Modal, ModalCTA } from 'containers/misc'
import { Title } from 'components/layout'
import { Button, FormData, List, Module } from 'components/misc'
import config from 'config'

const listActions = [
  {
    label: 'Delete account',
    intlKey: 'participant.delete_account',
    action: 'deleteAccount',
    url: `${config.publicPath}/`
  }
]

export default class OfficeSummary extends Component {
  static propTypes = {
    data: PropTypes.object.isRequired,
    modal: PropTypes.func.isRequired,
    onDeleteContact: PropTypes.func.isRequired
  }

  state = {
    deleteConfirmDialogOpen: false
  }

  handleItemSelect = action => {
    switch (action) {
      case 'deleteAccount':
        this.handleDeleteDialogOpen()
        break
      default:
    }
  }

  handleDeleteDialogOpen = () =>
    this.setState({ deleteConfirmDialogOpen: true })

  handleDialogClose = () => this.setState({ deleteConfirmDialogOpen: false })

  render () {
    const { onDeleteContact, data } = this.props

    const { deleteConfirmDialogOpen } = this.state

    const buttonDefinition = [
      {
        'order': 1,
        'secondary': true,
        'onClick': () => this.props.modal('contact-account-settings'),
        'iconAction': 'settings',
        'isActionLoading': false,
        'intlKeyAction': 'button.contact_settings',
        'action': 'Contact Settings'
      }
    ]

    return (
      <div>
        <Module
          buttonDefinition={buttonDefinition}
          primary
          first
          grid
        >
          <FormData label="Activation date" intlKey="label.activation_date">
            {get(data, 'person.createdAt')
              ? <FormattedDate value={get(data, 'person.createdAt')} />
              : '---'}
          </FormData>
        </Module>
        <Modal id="contact-account-settings" compact>
          <div className="row">
            <div className="col-xs-12">
              <Title h2 intlKey="moduleTitle.contact_settings">
                Contact settings
              </Title>
              <List data={listActions} onSelect={this.handleItemSelect} />
            </div>
          </div>
          {deleteConfirmDialogOpen &&
            <ModalCTA>
              <div className="row">
                <div className="col-xs-12">
                  <h2 className="text--center">
                    <FormattedMessage
                      id="participant.would_you_like_to_remove"
                      defaultMessage="Would you like to delete this account?"
                    />
                  </h2>
                </div>
                <div className="col-xs-6">
                  <Button
                    type="button"
                    onClick={this.handleDialogClose}
                    secondary
                  >
                    <FormattedMessage
                      id="button.close"
                      defaultMessage="Close"
                    />
                  </Button>
                </div>
                <div className="col-xs-6 text--right">
                  <Button
                    type="button"
                    negative
                    onClick={() => onDeleteContact(get(data, 'id'))}
                  >
                    <FormattedMessage
                      id="button.confirm"
                      defaultMessage="Confirm"
                    />
                  </Button>
                </div>
              </div>
            </ModalCTA>}
        </Modal>
      </div>
    )
  }
}
